app.controller('accountChangePasswordController', ['$scope', '$state', '$timeout', 'objectHelper', 'applicationModel', 'userModel',
    function ($scope, $state, $timeout, objectHelper, applicationModel, userModel) {

        function setData() {
            $scope.oldPassword = null;
            $scope.newPassword = null;
            $scope.repeatNewPassword = null;

            $scope.headerLabel = $state.current.data.header;

            $scope.forms = {
                accountForm: null
            }
        }

        function setPermissions() {
        }

        function setListeners() {
            var formChangeUnwatcher = $scope.bindChange(function() { return $scope.forms.accountForm.$dirty }, function (newValue, oldValue, scope) {
                if (newValue) {
                    applicationModel.viewDirty = true;
                }
            }, $scope);

            $scope.$on('$destroy', function(event) {
                formChangeUnwatcher();
                $scope.unbind($scope);
                applicationModel.viewDirty = false;
                applicationModel.viewReady = false;
            });
        }

        function setActions() {
            $scope.goBack = function () {
                $state.go(Constant.STATE.APP.ACCOUNT.HOME);
            };

            $scope.changePassword = function () {
                $scope.forms.accountForm.$setSubmitted();

                if ($scope.forms.accountForm.$valid) {
                    userModel.changePassword($scope.oldPassword, $scope.newPassword);

                    var successWatcherDisabler = $scope.$on(Event.USER.CHANGE_PASSWORD.SUCCESS, function (event, result) {
                        successWatcherDisabler();
                        errorWatcherDisabler();

                        applicationModel.viewDirty = false;

                        // wait for userModel.currentUser change to populate to ApplicationController in next digest
                        $timeout(function() {
                            if ($state.current.name == Constant.STATE.APP.ACCOUNT.PASSWORD_CHANGE_REQUIRED) {
                                $state.go(Constant.STATE.APP.HOME);
                            } else {
                                $scope.goBack();
                            }
                        });
                    });

                    var errorWatcherDisabler = $scope.$on(Event.USER.CHANGE_PASSWORD.ERROR, function (event, error) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                    });
                }
            };
        }

        function configureInterface() {
            applicationModel.deselectSideBarItems();

            var breadcrumbItems = [
                objectHelper.o(EsBreadcrumbItem, { name: 'T.UI.BREADCRUMB.ACCOUNT.MY_ACCOUNT', state: Constant.STATE.APP.ACCOUNT.HOME }),
                objectHelper.o(EsBreadcrumbItem, { name: 'T.UI.BREADCRUMB.ACCOUNT.PASSWORD_CHANGE', state: Constant.STATE.APP.ACCOUNT.CHANGE_PASSWORD })
            ];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar($scope.headerLabel);
        }

        function initialize() {
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
